module.exports = __webpack_public_path__ + "static/media/SungImage@2x.4017bf91.png";